const pagesLaborCoreInstanceEn = {
  assignee: 'Assignee',
  instanceStatus: {
    archived: 'Archived',
    completed: 'Completed',
    inProgress: 'In Progress'
  },
  laborCore: 'Labor Core',
  notStarted: 'This operation task is not started yet and cannot be edited. It starts when the dependent prior operation task is completed.',
  progress: {
    title: 'Task Progress'
  },
  requestedFor: 'Requested for',
  tabs: {
    data: 'Data',
    detail: 'Detail',
    operationActivity: 'Operation Activity'
  },
  task: {
    approveSuccess: 'Task approved successfully',
    editSuccess: 'Task updated successfully'
  }
};
export default pagesLaborCoreInstanceEn;